<template>
  <div :class="selected && 'selected'" class="pricing-table elevation-3">
    <div class="pricing-table_title secondary" :style="{ backgroundImage: `url(${ally.banner})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', minHeight: '70px', aspectRatio: '16 / 9' }">
      <h3 v-if="ally.banner === null" class="headline mb-0">{{ ally.name }}</h3>
      <h3 v-else></h3>
        <v-icon
        color="success"
        @click="toggleSelected"
        :disabled="
          ally.payment.payment_state === 'APPROVED' ||
            ally.payment.payment_state === 'PENDING'
        "
      >
        {{
          selected || ally.payment.payment_state === "APPROVED"
            ? "check_box"
            : "check_box_outline_blank"
        }}
      </v-icon>
    </div>
    <div
      v-if="
        !ally.payment.payment_state ||
          ally.payment.payment_state === 'DECLINED' ||
          ally.payment.payment_state === 'ERROR'
      "
      class="pricing-table_content"
    >
      <div
        class="d-flex error pa-1"
        v-if="
          ally.payment.payment_state &&
            (ally.payment.payment_state === 'DECLINED' ||
              ally.payment.payment_state === 'ERROR')
        "
      >
        <span class="white--text">
          {{ ally.name=="ASOPAF"?"El último pago fue" :"La última donación fue"  }}
          {{ $t(`enrollments.payment_status.${ally.payment.payment_state}`) }}
        </span>
      </div>
      <p>{{ ally.description }}</p>
      <div class="value" v-for="cost in ally.active_costs" :key="cost.id">
        <div class="label">
          <v-icon v-if="cost.icon" class="mr-3">{{ cost.icon }}</v-icon>
          <v-icon v-else class="mr-3">remove</v-icon>
          <v-icon color="primary" @click="selectCost(cost.id)">
            {{
              selectedCostValue == cost.id
                ? "radio_button_checked"
                : "radio_button_unchecked"
            }}
          </v-icon>

          <span class="ml-2">{{ cost.description }}</span>
        </div>
        <div class="price">
          <span>{{ formatNumber(cost.cost) }}</span>
        </div>
      </div>
      <div class="value" v-if="ally.allow_partial_payment == 1">
        <div class="label">
          <v-icon color="primary" @click="selectCost('OTHER')">
            {{
              selectedCostValue == "OTHER"
                ? "radio_button_checked"
                : "radio_button_unchecked"
            }}
          </v-icon>
          <span class="ml-2">Otro Valor:</span>
        </div>
        <div class="price">
          <span>
            <form @keydown="form.onKeydown($event)">
              <v-text-field
                ref="partial_payment"
                :form="form"
                label=""
                :v-errors="errors"
                :value.sync="form.partial_payment"
                name="partial_payment"
                v-validate="'required'"
                v-model="form.partial_payment"
                @keypress="onlyNumbers"
                prefix="$"
                v-money="money"
              ></v-text-field>
            </form>
          </span>
        </div>
      </div>
      <div class="value">
        <div class="label">
          <v-icon color="red" @click="toggleSelected">
            {{ !selected ? "check_box" : "check_box_outline_blank" }}
          </v-icon>

          <span class="ml-2">{{ $t(`enrollments.not_right_now`) }}</span>
        </div>
      </div>
    </div>
    <payment-proof
      v-if="
        ally.payment.payment_state === 'PENDING' ||
          ally.payment.payment_state === 'APPROVED'
      "
      :payment="ally.payment"
      :ally="ally"
      :payment_detail="`${ally.name}`"
    >
    </payment-proof>
    <div class="pricing-table_footer">
      <v-divider></v-divider>
      <v-btn
        v-if="
          !ally.payment.payment_state ||
            ally.payment.payment_state === 'DECLINED' ||
            ally.payment.payment_state === 'ERROR'
        "
        color="success"
        :disabled="!selected"
        @click="wompiPay"
        >{{ ally.name=="ASOPAF"?$t(`enrollments.pay`) :$t(`enrollments.donate`)  }}</v-btn
      >
      <v-btn
        v-if="ally.payment.payment_state === 'PENDING'"
        color="warning"
        :disabled="!selected"
        @click="wompiVerifyPay(ally.payment.traceability_code, ally.payment.id)"
        >{{ ally.name=="ASOPAF"?"Pago Pendiente - Verificar" :"Pago Donación Pendiente - Verificar"  }}</v-btn
      >
      <v-btn
        v-if="ally.payment.payment_state === 'APPROVED'"
        color="success"
        :disabled="true"
        > {{ ally.name=="ASOPAF"?"Pago aprobado" :"Donación Aprobada"  }} </v-btn
      >
    </div>
  </div>
</template>

<script>
import { VMoney } from "v-money";
import Form from "vform";
import axios from "axios";
import paymentProof from "../payment/proof";

export default {
  name: "enrollment-payment-ally-component",
  components: {
    "payment-proof": paymentProof
  },
  props: {
    ally: {
      type: Object,
      required: false
    },
    enrollment_id: {
      type: Number | String,
      required: false
    },
    student_id: {
      type: Number | String,
      required: false
    },
    family_id: {
      type: Number | String,
      required: false
    },
    defaultSeleted: {
      type: Number,
      required: false
    },
    enrollment_status_id: {
      type: Number | String,
      required: false
    }
  },
  data() {
    return {
      selected: true,
      form: new Form({
        partial_payment: 0
      }),
      selectedCost: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false
      }
    };
  },
  created() {
    const urlPayment = this.$route.query.payment;
    const urlStep = this.$route.query.step;
    const urlStudentId = this.$route.query.stdi;
    const wompiId = this.$route.query.id;
    if (
      urlPayment === "wompi" &&
      urlStep == 5 &&
      urlStudentId == this.student_id
    ) {
      if (this.ally.payment.payment_state === "PENDING") {
        this.wompiVerifyPay(wompiId, this.ally.payment.id);
      }
    }
  },
  directives: { money: VMoney },
  computed: {
    selectedCostValue() {
      return this.selectedCost || this.defaultSeleted;
    },
    totalPayment() {
      let total = 0;

      if (this.selectedCostValue === "OTHER") {
        total = this.form.partial_payment.replace(/\./gi, "");
      } else {
        const selectedCost = this.ally.active_costs.find(
          cost => cost.id === this.selectedCostValue
        );
        if (selectedCost) {
          total = selectedCost.cost;
        }
      }

      return total;
    },
    wompiPaymentReference() {
      return `${Date.now()}_${this.enrollment_status_id}_${this.ally.id}`;
    },
    wompiSignatureIntegrity() {
      const currency = "COP";
      const concat = `${this.wompiPaymentReference}${this.totalPayment}${currency}`;
      return concat;
    }
  },
  methods: {
    toggleSelected() {
      this.selected = !this.selected;
      this.toggleChecked();
    },
    toggleChecked() {
      const step = this.selected ? 1 : -1;
      this.$emit("toggleChecked", step);
    },
    selectCost(costId) {
      this.selectedCost = costId;
    },
    async wompiPay() {
      const { wompi_public_key, wompi_url } = this.ally;
      if (
        !wompi_public_key ||
        wompi_public_key == "" ||
        !wompi_url ||
        wompi_url == ""
      ) {
        this.$store.dispatch("responseMessage", {
          type: "error",
          text: "Este Aliado no contiene datos de pago válidos",
          title: "Error iniciando pago",
          modal: true
        });
        return;
      }
      const checkout = new WidgetCheckout({
        currency: "COP",
        amountInCents: this.totalPayment * 100,
        reference: this.wompiPaymentReference,
        publicKey: wompi_public_key,
        redirectUrl: `${window.config.wru}?payment=wompi&step=5&stdi=${this.student_id}`
      });
      const transactionPayload = {
        enrollment_status_id: this.enrollment_status_id,
        total: this.totalPayment,
        payment_reference: this.wompiPaymentReference,
        enrollment_id: this.enrollment_id,
        student_id: this.student_id,
        family_id: this.family_id,
        allies_id: this.ally.id,
        allies_cost_id:
          this.selectedCostValue === "OTHER" ? 0 : this.selectedCostValue
      };
      const result = await axios.post(
        "/api/enrollment/wompi/createTransaction",
        transactionPayload
      );
      if (result.status !== 200) {
        this.$store.dispatch("responseMessage", {
          type: "error",
          text: result.data.message,
          title: "Error al iniciar pago",
          modal: true
        });
        return;
      }
      const payment_id = result.data.payment_created;
      checkout.open(result => {
        const {
          transaction: {
            id,
            paymentMethodType,
            reference,
            status,
            amountInCents
          }
        } = result;

        const resultPayload = {
          payment_id,
          id,
          paymentMethodType,
          reference,
          status,
          total: amountInCents / 100
        };

        this.updateWompiTrans(resultPayload);
      });
    },
    wompiVerifyPay(wompi_id, payment_id) {
      const { wompi_url } = this.ally;

      fetch(`${wompi_url}/transactions/${wompi_id}`)
        .then(response => response.json())
        .then(({ data }) => {
          console.log(data);
          const {
            id,
            payment_method_type: paymentMethodType,
            reference,
            status,
            amount_in_cents: amountInCents
          } = data;

          const resultPayload = {
            payment_id,
            id,
            paymentMethodType,
            reference,
            status,
            total: amountInCents / 100
          };

          this.updateWompiTrans(resultPayload);
        });
    },
    updateWompiTrans(payload) {
      const { status } = payload;
      const newPayload = {
        ...payload,
        allyName: this.ally.name,
        allyBodyEmail: this.ally.email_body
      };
      axios
        .post("/api/enrollment/wompi/updateTransaction", newPayload)
        .then(resp => {
          if (resp.status === 200) {
            let message_text = "";
            let alert_type = "";
            if (status === "PENDING") {
              alert_type = "warning";
              message_text = "El pago se encuentra pendiente";
            }
            if (status === "APPROVED") {
              alert_type = "success";
              message_text = "El pago ha sido aprobado";
            }
            if (
              status === "DECLINED" ||
              status === "VOIDED" ||
              status === "ERROR"
            ) {
              alert_type = "error";
              message_text = "El pago ha sido rechazado";
            }
            this.$emit("refreshData");
            this.$store.dispatch("responseMessage", {
              type: alert_type,
              text: message_text,
              title: `Pago para ${this.ally.name}`,
              modal: true
            });
          }
        });
    },
    onlyNumbers($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode == 45) {
        //This is a code por - (minus sign)
        $event.preventDefault();
      }
    },
    formatNumber(number) {
      if (!number || typeof number === "undefined") {
        return 0;
      } else {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    }
  }
};
</script>

<style scoped>
.radioW {
  width: 100% !important;
}
.pricing-table {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.pricing-table_title {
  display: flex;
  justify-content: space-between;
  color: white;
  padding: 15px 15px;
}

.pricing-table_footer,
.pricing-table_content {
  padding: 15px;
}

.value {
  padding: 10px 5px;
  display: flex;
  justify-content: space-between;
  align-items: center !important;
  align-items: flex-end;
}

.label {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 15px;
}

.price {
  font-weight: bold;
}

.pricing-table_footer {
  text-align: center;
}

.selected {
  animation: crecer 300ms;
  transform: scale(1.04);
  border: solid 0.5px grey;
}

@keyframes crecer {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.04);
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/payment_ally.vue